import { render, staticRenderFns } from "./EducationalServicesRow.vue?vue&type=template&id=01831362&scoped=true"
import script from "./EducationalServicesRow.vue?vue&type=script&lang=js"
export * from "./EducationalServicesRow.vue?vue&type=script&lang=js"
import style0 from "./EducationalServicesRow.vue?vue&type=style&index=0&id=01831362&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01831362",
  null
  
)

export default component.exports